@if (!item.hideSelect) {
  <div
    #toggleButton
    (click)="toggle(item)"
    [ngClass]="{ selected: item.selected, disabled: disableToggle }"
    attr.name="RowSelect0_{{ item.name }}"
    class="row-toggle tSelect"
    id="RowSelect0_{{ item.id }}"
    attr.data-id="{{item.id}}"
    [matTooltip]="tooltip"
  ></div>
}
